import { NCS_COLORS, type NcsColorOption } from "./ncsColors";

/**
 * Returns the first NCS palette entry whose hex matches (case-insensitive).
 */
export function findNcsColorByHex(
  hex: string | undefined,
): NcsColorOption | undefined {
  if (!hex) {
    return undefined;
  }
  const normalized = hex.trim().toUpperCase();
  if (!normalized) {
    return undefined;
  }
  return NCS_COLORS.find((color) => color.hex.toUpperCase() === normalized);
}

/**
 * Short code without the leading "NCS " prefix, e.g. "S 0500-N".
 */
export function getNcsShortCode(option: NcsColorOption): string {
  return option.name.replace(/^NCS\s+/i, "");
}
